import http from './http';

const httpDelete = async (url, params = undefined, config = undefined) => {
  const response = await http.delete(url, { ...config, params });
  return response.data;
};

export default httpDelete;
